
import { Component, Vue, Watch } from 'vue-property-decorator'
import { TransTopReq, RefreshConfig } from '@/api/admin/risk'
import { getTableSetting, setTableSetting } from '@/libs/util'
import { tableSettingModel } from '@/libs/config'
import moment from 'moment'
@Component({
  components: {}
})
export default class userRiskConf extends Vue {
  tableSetting: any = {}
  loading: boolean = false
  refresLoading: boolean = false
  TransTopReqTimer: any
  TransTopReqTimerR: any
  select = {
    risk_type_List: [
      { name: '强制杀', value: 1 },
      { name: '系统自动', value: 0 },
      { name: '直杀', value: 2 }
    ],
    dataTime: [],
    log_DataTime: [
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    ],
    pvp_level_LIst: [
      { value: 2, name: '黑2' },
      { value: 1, name: '黑1' },
      { value: 0, name: '正常' },
      { value: -1, name: '白1' },
      { value: -2, name: '白2' }
    ],
    ctype_List: [
      { value: 1, name: '进入风控库' },
      { value: 2, name: '移除风控库' },
      { value: 3, name: '修改风控类型' },
      { value: 4, name: '修改投注增量' },
      { value: 5, name: '修改备注信息' },
      { value: 6, name: '修改风控值' },
      { value: 7, name: '返奖率' }
    ]
  }
  tableMaxHeight = 0
  //表单数据
  table = {
    params: {
      platids: [],
      app_ids: [],
      _param: <any>{
        platform: 0,
        platid: 0,
        app_id: 0,
        risk_type: -1,
        page: 1,
        pageSize: 10000,
        start: 0,
        end: 0,
        uid: ''
      }
    },
    dataAll: <any>[],
    data: <any>[],
    columns: [
      { type: 'index', title: '序号', width: 50, align: 'center' },
      {
        key: 'platname',
        align: 'center',
        width: 110,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '所属平台', '显示对应玩家所属平台')
      },
      {
        key: 'appname',
        align: 'center',
        width: 110,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '所属APP', '显示对应玩家所属APP')
      },
      {
        key: 'uid',
        align: 'center',
        width: 110,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '玩家ID', '显示对应风控配置的玩家的UID')
      },
      {
        key: 'bet',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) =>
          h('span', (this as any).getCustomFixed(params.row.bet / 10000)),
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '投注金额', '显示玩家的历史投注金额')
      },
      {
        key: 'incr_bet',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => {
          let color = '#333'
          if (params.row.incr_bet > 0) {
            color = '#32CD32'
          } else if (params.row.incr_bet < 0) {
            color = 'red'
          }
          return h(
            'span',
            { style: { color: color } },
            (this as any).getCustomFixed(params.row.incr_bet)
          )
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '投注增减量',
            '• 显示针对该玩家配置的投注增减量；• 当风控类型为系统自动时，显示配置的数值；• 当风控类型为强制杀时，隐藏配置的数值；'
          )
      },
      {
        key: 'hit',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) =>
          h('span', (this as any).getCustomFixed(params.row.hit / 10000)),
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '返奖金额', '显示玩家的历史返奖金额')
      },
      {
        key: 'win',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) =>
          h('span', (this as any).getCustomFixed(params.row.win / 10000)),
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '玩家盈亏',
            '历史返奖金额-历史投注金额-投注增减量'
          )
      },
      {
        key: 'win_pros',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => h('span', params.row.win_pros.toFixed(2) + '%'),
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '盈亏率',
            '玩家盈亏率=玩家盈亏/（玩家投注金额+投注增减量）'
          )
      },
      {
        key: 'risk_type',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => {
          let arr = ['系统自动风控', '强制杀风控', '直杀']
          let color = ['red', '#32CD32', 'blue']
          return h(
            'span',
            { style: { color: color[params.row.risk_type] } },
            arr[params.row.risk_type]
          )
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '风控类型',
            '• 强制杀：强制系统每一局前根据配置概率判定对玩家是否进行风控；（独立平行场）• 系统自动风控：根据系统判定每一局对该玩家是否风控；（正常游戏）'
          )
      },
      {
        key: 'risk_val',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => {
          let str = params.row.risk_val ? params.row.risk_val + '%' : '/'
          return h('span', { style: { color: 'red' } }, str)
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '百人类风控强度',
            '• 显示当前玩家如果开启【强制杀】时，每一局触发风控的概率；• 当风控类型为强制杀时，显示配置的数值；• 当风控类型为系统自动时，隐藏配置的数值'
          )
      },
      {
        key: 'bet_limit',
        align: 'center',
        width: 110,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '直杀下限', '直杀投注下限数额')
      },
      {
        key: 'prize_rate',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => {
          let str = params.row.prize_rate + '%'
          return h('span', str)
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '单人游戏返奖率', '•监控玩家的返奖率')
      },
      {
        key: 'pvp_level',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => {
          let arr = ['白2', '白1', '正常', '黑1', '黑2']
          let color = ['#32CD32', '#32CD32', '#333', 'red', 'red']
          return h(
            'span',
            { style: { color: color[params.row.pvp_level + 2] } },
            arr[params.row.pvp_level + 2]
          )
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, 'PVP风控等级', '•监控玩家的返奖率')
      },
      {
        key: 'created_date',
        align: 'center',
        width: 110,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '添加风控时间',
            '显示新增风控该玩家进入玩家风控名单的时间；'
          )
      },
      {
        key: 'reason',
        title: '风控备注',
        align: 'center',
        width: 110,
        resizable: true,
        render: (h, params) => h('span', params.row.reason),
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '风控备注',
            '显示新增风控该玩家进入玩家风控名单的备注；'
          )
      },
      {
        title: '管理',
        key: 'action',
        align: 'center',
        fixed: (this as any).isMOble() ? '' : 'right',
        minWidth: 120,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '3px 8px' },
                on: {
                  click: () => {
                    this.ModalShow('set', params.row)
                    this.setUser_modal.data.bit = params.row.bet
                    this.setUser_modal.data.hit = params.row.hit
                  }
                }
              },
              '修改'
            ),
            h(
              'Button',
              {
                props: { type: 'error' },
                style: { margin: '2px', padding: '3px 8px' },
                on: {
                  click: () => {
                    this.removemsg(params.row)
                  }
                }
              },
              '删除'
            )
          ])
        }
      }
    ],
    total: 0,
    pageSize: 10,
    page: 1,
    pageSizes: [10, 20, 30, 40]
  }
  //风控玩家配置
  setUser_modal = {
    show: false,
    ref: 'setUser',
    params: this.getSetUserParams(0, 0),
    data: { bit: 0, hit: 0 },
    rules: {
      uid: [
        {
          required: true,
          trigger: 'blur',
          validator: (this as any).simpleVerify('请输入用户UID')
        }
      ]
    }
  }
  //玩家风控修改日志
  Log_modal = {
    show: false,
    app_id: 0,
    platid: 0,
    params: <any>{
      page_size: 10,
      page: 1,
      ctype: 0,
      manager_id: '',
      uid: '',
      start: 0,
      end: 0
    },
    columns: [
      { type: 'index', title: '序号', width: 50, align: 'center' },
      { key: 'id', title: '日志ID', align: 'center' },
      { key: 'uid', title: '玩家ID', align: 'center' },
      {
        key: 'old_val',
        title: '修改项',
        align: 'center',
        render: (h, params) => {
          let str = this.select.ctype_List.filter(
            item => item.value == params.row.ctype
          )[0].name
          return h('span', str)
        }
      },
      {
        key: 'old_val',
        title: '修改前',
        align: 'center',
        render: (h, params) => {
          let str: any
          if (params.row.ctype == 1 || params.row.ctype == 2) {
            str = '/'
          } else if (params.row.ctype == 3) {
            if (params.row.old_val == 1) {
              str = '强制杀'
            } else if (params.row.old_val == 0) {
              str = '系统自动'
            } else {
              str = '直杀'
            }
          } else if (params.row.ctype == 4 || params.row.ctype == 5) {
            str = params.row.old_val
          } else if (params.row.ctype == 6 || params.row.ctype == 7) {
            str = params.row.old_val + '%'
          }

          return h('span', str)
        }
      },
      {
        key: 'new_val',
        title: '修改后',
        align: 'center',
        render: (h, params) => {
          let str: any
          if (params.row.ctype == 1 || params.row.ctype == 2) {
            str = '/'
          } else if (params.row.ctype == 3) {
            if (params.row.new_val == 1) {
              str = '强制杀'
            } else if (params.row.new_val == 0) {
              str = '系统自动'
            } else {
              str = '直杀'
            }
          } else if (params.row.ctype == 4 || params.row.ctype == 5) {
            str = params.row.new_val
          } else if (params.row.ctype == 6 || params.row.ctype == 7) {
            str = params.row.new_val + '%'
          }
          return h('span', str)
        }
      },
      { key: 'created_date', title: '修改时间', align: 'center' },
      { key: 'manager_id', title: '操作账户ID', align: 'center' }
    ],
    data: [],
    total: 0,
    pageSizes: [10, 20, 30, 40]
  }
  //分组变化清空盘口选择项
  updateSelect() {
    this.Log_modal.app_id = 0
  }
  getSetUserParams(platid, appid) {
    return {
      uid: '',
      id: 0,
      platid,
      appid,
      incr_bet: 0,
      risk_type: 0,
      risk_val: 0,
      prize_rate: 0,
      pvp_level: 0,
      bet_limit: 0,
      pvp_rate: 0,
      reason: ''
    }
  }
  updatePlat() {
    this.setUser_modal.params.appid = (this as any).app_list.find(
      el => el.platform == this.setUser_modal.params.platid
    ).appid
  }
  getUpdateAppList() {
    return (this as any).app_list.filter(
      el => el.platform == this.setUser_modal.params.platid
    )
  }
  // 同步配置
  async Refres() {
    if (this.refresLoading) return
    let allList: any = (this as any).getAllHttpAppid(this.table.params)
    let httpList: any = []
    let loadingArr = [...allList]
    let params: any = {}
    for (let i = 0, len = allList.length; i < len; i++) {
      let app_id = allList[i]
      let platid = 0
      let item: any = (this as any).app_list.find(
        (el: any) => el.appid == app_id
      )
      if (item) {
        platid = item.platform
      }
      params.app_id = app_id
      params.ctype = 2
      let param: any = this.getTransParams('RefreshConfig', params, {
        platid,
        app_id
      })
      httpList.push(param)
    }
    for (let s = 0; s < 5; s++) {
      this.toHttpRefresh(httpList, loadingArr)
    }
  }
  async toHttpRefresh(httpList: any, loadingArr: any) {
    if (httpList.length > 0) {
      let param = httpList.shift()
      this.openTimerR()
      TransTopReq(param)
        .then(res => {
          loadingArr.shift()
          if (loadingArr.length == 0) {
            this.$Notice.success({
              title: '操作提示',
              desc: '成功刷新配置'
            })
            this.closeTimerR()
          }
          this.toHttpRefresh(httpList, loadingArr)
        })
        .catch(err => {
          this.toHttpRefresh(httpList, loadingArr)
        })
    }
  }
  //获取列表
  async getUserRiskList(num?) {
    if (num) {
      this.table.page = 1
      this.table.pageSize = 10
      // if (!this.table.params.platids.length) {
      //   this.$Message.error('请筛选平台信息')
      // }
      if (!this.table.params.app_ids.length) {
        this.$Message.error('请筛选APP盘口')
      }
    }
    if (this.loading) return
    this.table.params._param.start = this.select.dataTime.length
      ? (this as any).getSecond(this.select.dataTime[0])
      : 0
    this.table.params._param.end = this.select.dataTime.length
      ? (this as any).getSecond(this.select.dataTime[1], false)
      : 0
    this.table.params._param.risk_type =
      this.table.params._param.risk_type == undefined
        ? -1
        : this.table.params._param.risk_type
    let params: any = {
      ...this.table.params._param,
      uid: Number(this.table.params._param.uid)
    }
    let allList: any = (this as any).getAllHttpAppid(this.table.params)
    let httpList: any = []
    let loadingArr = [...allList]
    for (let i = 0, len = allList.length; i < len; i++) {
      let app_id = allList[i]
      let platid = 0
      let item: any = (this as any).app_list.find(
        (el: any) => el.appid == app_id
      )
      if (item) {
        params.platid = item.platform
        params.platform = item.platform
      }
      params.app_id = app_id
      let param: any = this.getTransParams('GetUserRiskList', params, {
        platid: params.platid,
        app_id
      })
      httpList.push(param)
    }
    this.table.dataAll = []
    for (let s = 0; s < 5; s++) {
      this.toHttp(httpList, loadingArr)
    }
  }
  async toHttp(httpList: any, loadingArr: any) {
    if (httpList.length > 0) {
      let param = httpList.shift()
      this.openTimer()
      TransTopReq(param)
        .then(res => {
          let data: any = res._param.data || []
          let platitem =
            (this as any).plat_list.find(el => el.id == param.platid) || {}
          let platname = platitem.name || ''
          let appitem =
            (this as any).app_list.find(el => el.appid == param.app_id) || {}
          let appname = appitem.appName || ''
          data.forEach((item: any) => {
            item.platname = platname
            item.appname = appname
            // this.table.data.push(item);
            this.table.dataAll.push(item)
          })
          loadingArr.shift()
          if (loadingArr.length == 0) {
            this.closeTimer()
            this.tableChangePage()
          }
          this.toHttp(httpList, loadingArr)
        })
        .catch(err => {
          this.toHttp(httpList, loadingArr)
        })
    }
  }
  //关闭定时器
  closeTimer() {
    this.loading = false
    clearTimeout(this.TransTopReqTimer)
    this.TransTopReqTimer = null
  }
  //批量请求开启定时器8秒超时
  openTimer() {
    this.closeTimer()
    this.loading = true
    this.TransTopReqTimer = setTimeout(() => {
      this.loading = false
    }, 6000)
  }
  //关闭定时器
  closeTimerR() {
    this.refresLoading = false
    clearTimeout(this.TransTopReqTimerR)
    this.TransTopReqTimerR = null
  }
  //批量请求开启定时器8秒超时
  openTimerR() {
    this.closeTimerR()
    this.refresLoading = true
    this.TransTopReqTimerR = setTimeout(() => {
      this.refresLoading = false
    }, 6000)
  }
  //列表分页
  userMonitorcurrent(page) {
    this.table.page = page
    this.tableChangePage()
  }
  //列表分条
  userMonitorpage(limit) {
    this.table.pageSize = limit
    this.table.page = 1
    this.tableChangePage()
  }
  //table本地数据分页
  tableChangePage() {
    let data = JSON.parse(JSON.stringify(this.table.dataAll))
    this.table.total = data.length
    let m = (this.table.page - 1) * this.table.pageSize
    let n = this.table.page * this.table.pageSize
    this.table.data = data.slice(m, n)
  }
  ModalShow(type, row = {}) {
    let platid = (this as any).getinitPlatId()

    let appid = (this as any).app_list.find(el => el.platform == platid).appid

    let data = this.getSetUserParams(platid, appid)

    this.setUser_modal.params = { ...data, ...row }
    ;(this.$refs[this.setUser_modal.ref] as any).resetFields()

    this.setUser_modal.show = true
  }
  CloseModal() {
    ;(this.$refs[this.setUser_modal.ref] as any).resetFields()
    this.setUser_modal.show = false
  }
  prizeZrat() {
    if (this.setUser_modal.params.prize_rate >= 100) {
      this.$Modal.confirm({
        title: '确认信息',
        content: '<p>请确认单人游戏返奖率配置是否要超过100%</p>',
        onOk: () => {
          this.updatedrisk()
        },
        onCancel: () => {
          return false
        }
      })
    } else {
      this.updatedrisk()
    }
  }
  // 透传接口请求参数 请求方法 请求参数
  getTransParams(_func, params, from?) {
    let { platid, app_id } = from || params
    return {
      mod: 'root',
      platid,
      app_id,
      param: {
        _mod: 'manager',
        _func,
        _param: { ...params }
      }
    }
  }
  //修改新增风控玩家
  updatedrisk() {
    ;(this.$refs[this.setUser_modal.ref] as any).validate(valid => {
      if (valid) {
        let platid = this.setUser_modal.params.platid
        let app_id = this.setUser_modal.params.appid
        let _param = this.getTransParams(
          'UpdateUserRiskLog',
          {
            ...this.setUser_modal.params,
            uid: Number(this.setUser_modal.params.uid)
          },
          { platid, app_id }
        )
        TransTopReq(_param).then(res => {
          this.getUserRiskList()
          this.CloseModal()
        })
      }
    })
  }
  removemsg(row) {
    this.$Modal.confirm({
      title: '确认删除',
      content: '<p>是否确认将此玩家移出风控名单。</p>',
      onOk: () => {
        let _param = this.getTransParams(
          'DelUserRiskLog',
          { id: row.id, appid: row.appid },
          { platid: row.platid, app_id: row.appid }
        )
        TransTopReq(_param).then(res => {
          this.getUserRiskList()
        })
      },
      onCancel: () => {}
    })
  }
  //操作风控日志
  logshow() {
    this.Log_modal.show = true
    // this.getUserRiskLog(1);
  }
  //logshow
  //修改日志
  async getUserRiskLog(num?) {
    if (num) {
      this.Log_modal.params.page = 1
    }
    let { platid, app_id } = this.Log_modal
    let _param = this.getTransParams('GetUserRiskLog', {
      ...this.Log_modal.params,
      app_id,
      platid,
      uid: Number(this.Log_modal.params.uid),
      manager_id: Number(this.Log_modal.params.manager_id),
      start: (this as any).getSecond(this.select.log_DataTime[0]),
      end: (this as any).getSecond(this.select.log_DataTime[1], false)
    })
    TransTopReq(_param).then(res => {
      this.Log_modal.data = res._param.data || []
      this.Log_modal.total = res._param.total
    })
  }
  //列表分页
  LogModalPage(page) {
    this.Log_modal.params.page = page
    this.getUserRiskLog()
  }
  LogModalPageLimit(limit) {
    this.Log_modal.params.page = 1
    this.Log_modal.params.page_size = limit
    this.getUserRiskLog()
  }
  widthResize(val1, val2, val3) {
    this.tableSetting[val3.key] = val1
    setTableSetting(tableSettingModel.userRiskConf, this.tableSetting)
  }
  initTableSetting() {
    this.tableSetting = getTableSetting(tableSettingModel.userRiskConf)
    this.table.columns.forEach(element => {
      if (element.key && this.tableSetting[element.key]) {
        element.width = this.tableSetting[element.key]
      }
    })
  }
  created() {
    this.initTableSetting()
  }
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 270
  }
}
